import { BrandliveEvent, EventGroup } from './projects.types';

export interface ICreateV2Templates {
  name: string;
  description: string;
  channel: number;
  preview_image: string;
  properties: {
    registrationImage?: string;
    /**
     * @deprecated
     * All font/colors now comes from ThemePack.
     * Future templates will strictly be used for UI layouts, not styles.
     *
     * @see ThemePackTypes.ThemePack
     * */
    design: {
      font: number;
      colors: number;
      // style: //not being used right now
    };
  };
  css?: string | null;
  scss?: string | null;
  created_at?: Date;
  status?: TemplateStatus;
  // New parameters must be optional or nullable
}

export interface Template extends ICreateV2Templates {
  template: number;
}

export interface ITemplateEventTheme {
  name: string;
  preview_image?: string;
}

export enum TemplateStatus {
  deleted,
  active,
}

export interface IV2TemplateGroup {
  id: string;
  name: string;
  templateIds: number[];
}

// Do not change the order of enum Templates
// if creating new templates, append to the end
export enum Templates {
  Apollo = 1, //was "Classic"
  'Studio 54', //was "Bold"
  O2, //was "Fun"
  'Limelight', // Above and Below the fold
}

export interface TemplateEventInfo {
  name: BrandliveEvent['name'];
  description: BrandliveEvent['settings']['description'];
  groups: EventGroup['uuid'][];
  event_image?: string;
}

export interface TemplateCategoryFiltersTable {
  uuid: string;
  title: string;
  channel: number;
}

export interface EventTemplateCategoryFilterTable {
  template_category_filter_uuid: string;
  event_uuid: string;
}

export interface TemplateCategoriesListItem {
  uuid: string;
  title: string;
  channel: number;
  events: TemplateCategoryEventInfo[];
}

export interface TemplateCategoryEventInfo {
  event_uuid: string;
  name: string;
}
